import {createLogger} from '../../common/logging.config';
const logger = createLogger('publishing-error-service');

module.exports = ['$http', '$q', '$filter', 'homepageUtil', 'shellUtil', 'userProfileService', function($http, $q, $filter, homepageUtil, shellUtil, userProfileService) {

	
	/**
	* Returns a promise to the JSON for the current publishing errors
	* @return {Promise}
	*/
	function getCurrentErrors() {
		let entriesError = [];
		
		return new Promise((resolve, reject) => {
			shellUtil.getProjects(true).then(
				(res) => {
					return res;
				},
				(error) => {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject (error);
				}
			).then(data => {
				if (typeof data === 'undefined') {
					logger.error('Error retrieving current project data from server: data was undefined');
					reject(new Error('No data from search for projects'));
				}
				if (data && data.numFound > 0) {
					for (let doc of data.documents) {
						let document = doc.document;
						if (document.status === "failed") {
							logger.info(" got document name: " + document.name);
							if (document.name) {
								//let targetDate = new Date(document.targetDate);
								//let timeString = targetDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
								// store with each body entry the detailed time for sorting
								//let bodyDateString = "" + targetDate.getTime();
								// now normalize all target dates to same
								//targetDate.setHours(0,0,0,0);
								//let dateString = "" + targetDate.getTime();
								//let titleString = targetDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
								const titleString = 'Publishing failed';
								let displayName = document.creator || document.creatorId; 
								let bodyEntry = {bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, /*bodyEntryCount: document.itemCount, time:bodyDateString,*/ bodyId: document.id, bodyKind: document.kind};
								let match = entriesError.find( element => { return element.title === titleString} );
								if (!match) {
									let bodyArray = [];
									bodyArray.push(bodyEntry);
									entriesError.push({/*date:dateString,*/ title:titleString, /*time:timeString,*/ body:bodyArray});
								}
								else {
									let bodyArray = match.body;
									bodyArray.push(bodyEntry);
								}
							}
						}
					}
				}
				
				// lookup the id of the current user
				userProfileService.getCurrentUserData().then((data) => {
					return data.id;
				}).then(userId => {
					homepageUtil.getPublishingAtAGlancePreferences().then((userPrefs) => {
						let filteredContent = $filter('publishingPreferencesFilter')(entriesError, userPrefs, userId);
						resolve (filteredContent);
					});
				});
			});
		});
	}

	/**
	* Returns a promise to the JSON for the current error count
	* @return {Promise}
	*/
	function getCurrentErrorCount() {
		return new Promise((resolve, reject) => {
			getCurrentErrors().then(
			(data) => {
				let ctr = 0;
				if (data.length > 0) {
					data.forEach(entry => {
						ctr+=entry.body.length;
					});
				}
				resolve({count:ctr});
			},
			(error) => {
				logger.error('Error: ' + JSON.stringify(error));
				resolve({count:0});
			});
		});
	}

	// return public API for the REST factory
    return {
    	getCurrentErrors: getCurrentErrors,
    	getCurrentErrorCount: getCurrentErrorCount
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/publishing-error-service.factory.js